module.exports = __webpack_public_path__ + "img/zoetrope4.c7844f73.gif";